module.exports = __webpack_public_path__ + "fonts/SangBleuKingdom-Medium.c0240aa.otf";